import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Sparkles, Loader2 } from "lucide-react";
import nextIcon from "../../assets/nextButtonIcon.png";
import "./WriteDogBioPage.css";
import apiClient from "../../api/apiClient";
import { ENDPOINTS } from "../../api/endPoints";
import { useGlobalAlert } from "../../context/AlertContext";
import MobileTopBar from "../../components/MobileTopBar";
import MobileBottomBar from "../../components/MobileBottomBar";
import DesktopTopBar from "../../components/DesktopTopBar";
import DesktopBottomBar from "../../components/DesktopBottomBar";

const WriteDogBioPage = ({ formData, setFormData }) => {
  const navigate = useNavigate();
  const { triggerAlert } = useGlobalAlert();

  const dogName = formData?.dogName || "Dog Name";

  const [bioText, setBioText] = useState(formData?.dogBio || "");
  const [loadingBio, setLoadingBio] = useState(false);

  const isBioValid = bioText.trim().length > 0;

  const handleGenerateAIBio = async () => {
    setLoadingBio(true);
    try {
      let breedPayload = formData?.dogBreed;
      if (formData?.dogBreed === "Mixed Breed") {
        breedPayload = [
          formData?.selectedBreed1,
          formData?.selectedBreed2,
          formData?.selectedBreed3,
        ].filter(Boolean);
      }

      const payload = {
        dog_name: formData?.dogName || "Dog",
        dog_gender: formData?.dogGender || "Not Specified",
        dog_breed: breedPayload || "Unknown",
        personality: formData?.dogPersonality || [],
      };

      const response = await apiClient.post(ENDPOINTS.GENERATE_AI_BIO, payload);

      if (response.data.success && response.data.AI_generated_bio) {
        setBioText(response.data.AI_generated_bio);
      } else {
        triggerAlert("Could not generate bio at this time.", "error");
      }
    } catch (error) {
      console.error("AI Bio Error:", error.response?.data || error.message);
      triggerAlert("Failed to generate bio. Please try again.", "error");
    } finally {
      setLoadingBio(false);
    }
  };

  const handleNext = () => {
    if (!bioText.trim()) return;

    setFormData((prev) => ({ ...prev, dogBio: bioText }));
    navigate("/completion-page");
  };

  const handleSkip = () => {
    navigate("/completion-page");
  };

  return (
    <div className="iyow-container">
      {/* Header */}
      {/* <header className="iyow-header desktop-only">
        <button
          className="iyow-back-btn"
          onClick={() => navigate("/exp-with-humans")}
        >
          <ArrowLeft size={22} color="#fff" strokeWidth={3} />
          <span>Back</span>
        </button>
      </header> */}
      <DesktopTopBar
        showBack={true}
        onBack={() => navigate("/exp-with-humans")}
        backColor="#fff"
        showProgress={false}
      />

      <MobileTopBar
        onBack={() => navigate("/exp-with-humans")}
        backColor="#fff"
        logoColor="#fff"
        isProtectedRoute={false}
      />

      {/* Main Content */}
      <main className="iyow-main-content">
        <h1 className="iyow-title">IN YOUR OWN WORDS</h1>
        <p className="iyow-subtitle">
          Share more about what brings you to Social Paws, {dogName}'s greatest
          traits, and whatever else your heart desires!
        </p>

        <div className="iyow-input-wrapper">
          <textarea
            className="iyow-textarea"
            placeholder="Write here"
            value={bioText}
            onChange={(e) => setBioText(e.target.value)}
          />
          <div className="iyow-action-group">
            <button
              type="button"
              className="iyow-ai-btn"
              onClick={handleGenerateAIBio}
              disabled={loadingBio}
            >
              {loadingBio ? (
                <Loader2 size={18} className="animate-spin" />
              ) : (
                <Sparkles size={18} strokeWidth={2} />
              )}
              {loadingBio
                ? "GENERATING..."
                : `WRITE ${dogName?.toUpperCase()}'S BIO`}
            </button>
            <p className="iyow-ai-help-text">
              Want a helping paw?
              <br />
              Let AI write the bio!
              <br />
              you can edit before saving
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      {/* <div className="paws-exp-footer-h desktop-only">
        <button className="paws-skip-btn-h" onClick={handleSkip}>
          SKIP
        </button>

        <button
          className={`iyow-next-btn ${isBioValid ? "enabled" : "disabled"}`}
          onClick={handleNext}
          disabled={!isBioValid}
        >
          <span className="paws-next-text-h">NEXT</span>
          <div className="paws-next-circle-h">
            <img
              src={nextIcon}
              alt="Next Icon"
              style={{
                width: "140%",
                height: "140%",
                objectFit: "contain",
                opacity: isBioValid ? 1 : 0.5,
              }}
            />
          </div>
        </button>
      </div> */}
      <DesktopBottomBar
        onNext={handleNext}
        isNextEnabled={isBioValid}
        nextIconSrc={nextIcon}
        showSkip={true}
        onSkip={handleSkip}
        variant="green"
      />

      <div className="paws-exp-footer-h mobile-only">
        <MobileBottomBar
          onNext={handleNext}
          isNextEnabled={isBioValid}
          nextIconSrc={nextIcon}
          showSkip={true}
          onSkip={handleSkip}
          variant="green"
        />
      </div>
    </div>
  );
};

export default WriteDogBioPage;
